import { Spin } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

// layout needs to be imported as first component
// otherwise css order breaks
// https://github.com/gatsbyjs/gatsby/issues/9733#issuecomment-490132623
import PerpetualMassesLayout from '../components/Layout/PerpetualMassesLayout/PerpetualMassesLayout';
import { useFetchAccountOptions } from '../api/actions/useFetchAccountOptions';
import PerpetualMassesNotActive from '../components/PerpetualMasses/PerpetualMassesNotActive/PerpetualMassesNotActive';
import { PerpetualMassesContent } from '../components/PerpetualMasses/PerpetualMassesContent/PerpetualMassesContent';
import selectors from '../store/selectors';

const PerpetualMasses = () => {
  const isPerpetualMassesActive = useSelector(selectors.selectPerpetualMassFeatureFlag);
  const isFetchingAccountOptions = useFetchAccountOptions();
  const perpetualMassOfferingAmount = useSelector(
    selectors.selectPerpetualMassOfferingAmountOption,
  );

  let content = null;
  if (isFetchingAccountOptions || perpetualMassOfferingAmount === undefined) {
    content = <Spin />;
  } else if (isPerpetualMassesActive) {
    content = <PerpetualMassesContent />;
  } else {
    content = <PerpetualMassesNotActive />;
  }

  return <PerpetualMassesLayout>{content}</PerpetualMassesLayout>;
};

export default PerpetualMasses;
